module.exports = __webpack_public_path__ + "img/man_gift.9627889d.svg";